module.exports = __webpack_public_path__ + "img/6-kodachrome.3918134.png";


//////////////////
// WEBPACK FOOTER
// ./uncommon-client/assets/6-kodachrome.png
// module id = xda4
// module chunks = 1